// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "code-example-vendor" + "." + "126d8316" + ".chunk.js";
};